import React, { useState } from "react";
import { useSelector } from "react-redux";

import SectionHeader from "@cayuse/shared-react.components.section-header";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import IconButton from "@cayuse/shared-react.components.icon-button";

import SaveNewVersionModal from "components/BudgetBuilder/Versions/SaveNewVerisonModal";
import VersionsTable from "components/BudgetBuilder/Versions/VersionsTable";
import { budgetBuilderSelectors } from "store/selectors";


const VersionsMainView = () => {
	const currentVersion = useSelector(budgetBuilderSelectors.currentVersion);
	const [ isNewVersionModalOpen, setIsNewVersionModalOpen ] = useState(false);

	const handleSave = () => {
		setIsNewVersionModalOpen(true);
	};

	return (
		<>
			<SaveNewVersionModal isOpen={isNewVersionModalOpen} onClose={() => setIsNewVersionModalOpen(false)} />
			<SectionHeader
				header={"Versions"}
				breadcrumbs={"A version is a snapshot of all info in the budget. New version may be saved at any time. Reverting to a saved version retains the originally saved version, and provides a new editable copy."}
				buttons={[
					<IconButton key="save" icon="plus" labelPosition="right" onClick={handleSave} disabled={!!currentVersion}>
						{"Save New Version"}
					</IconButton>
				]}
			/>
			<BasePadding>
				<VersionsTable/>
			</BasePadding>
		</>
	);
};

export default VersionsMainView;
